import React from 'react';
import PropTypes from 'prop-types';

import Tab from 'react/containers/layout/tabs/Tab';
import { DataSyncLogsList } from './DataSyncLogsList';

class DataSyncLogs extends Tab {
  static propTypes = {
    active: PropTypes.bool
  }

  static tabName = 'DataSyncLogs'

  activeClassName = 'is-active'

  render() {
    const { active } = this.props;

    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div id="DataSyncLogs" className={className}>
        <DataSyncLogsList />
      </div>
    );
  }
}

export default DataSyncLogs;
